import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  selectedCharacterId: -1,
  assignedSuperlatives: {},
};

// a reducer to store information about what character has been selected on the yearbook screen.
const characterScreenReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    default:
      return state;

    case REDUX_ACTIONS.DESELECT_CHARACTER:
      return {
        ...state,
        selectedCharacterId: -1,
      };

    case REDUX_ACTIONS.INITIALIZE_LEVEL: {
      const { characterIdsInRound } = payload;
      return {
        ...state,
        selectedCharacterId: -1,
        // turns every string in `CharactrIdsInRound` into a key of the `assignedSuperlatives` object.
        // every key will have an empty string as its value.
        assignedSuperlatives: characterIdsInRound.reduce((obj, addition) => ({
          ...obj,
          [addition]: '',
        }), {}),
      };
    }

    case REDUX_ACTIONS.SELECT_CHARACTER:
      return {
        ...state,
        selectedCharacterId: payload.characterId,
      };

    case REDUX_ACTIONS.SUBMIT_SUPERLATIVE:
      return {
        ...state,
        assignedSuperlatives: {
          ...state.assignedSuperlatives,
          [state.selectedCharacterId]: payload.superlativeText,
        },
      };

    case REDUX_ACTIONS.MERGE_GAME_STATE: {
      const { characterScreen } = payload;
      if (characterScreen) {
        return {
          ...state,
          ...characterScreen,
        };
      }
      return state;
    }
  }
};

export default characterScreenReducer;
